import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function authReducer (state=initialState.auth, action){
    switch(action.type) {
        case types.AUTH__CHANGE_LEGACY_USER_REQUEST:
        case types.AUTH__FORGOT_PASSWORD_REQUEST:
        case types.AUTH__AUTHENTICATE_USER_REQUEST:
            return {...state, loading:true, error: null};
        case types.AUTH__AUTHENTICATE_USER_FAILURE:
            return {...state, loading:false, authenticated: false, error: action.error};
        case types.AUTH__AUTHENTICATE_USER_SUCCESS:
            return {...state, loading:false, authenticated: true, error: null, password: null};
        case types.AUTH__UPDATE_USER:
            return {...state, ...action.user};
        case types.LOGIN__USER_REMEMBER_ME_REQUEST:
            return {...state, loading: true};
        case types.AUTH__FORGOT_PASSWORD_SUCCESS:
            return {...state, loading: false, passwordSent: true};  
        case types.AUTH__CHANGE_LEGACY_USER_FAILURE:    
        case types.AUTH__FORGOT_PASSWORD_FAILURE:
            return {...state, loading: false, error: action.error};
        case types.AUTH__SET_LEGACY_USER:
            return {...state,legacyUsername:action.username}
        case types.AUTH__CHANGE_LEGACY_USER_SUCCESS:                    
        case types.LOGIN__USER_REMEMBER_ME_SUCCESS:
        case types.LOGIN__USER_REMEMBER_ME_FAILURE:
            return {...state, loading: false};
        case types.LOGOUT__USER_SUCCESS:
            return {...initialState.auth};        
        default:
            return state;
    }
}


